module.exports = __webpack_public_path__ + "media/1x1/rs-d00d37d2.svg";